import { Checkbox } from 'components/common';
import { Controller, useFormContext } from 'react-hook-form';
import { ICheckboxProps } from './types';

export const FormCheckbox = (props: ICheckboxProps) => {
  const form = useFormContext();

  return (
    <Controller
      rules={props.rules}
      name={props.name || ''}
      control={form.control}
      render={({ field: { ref, ...renderProps } }) => (
        <Checkbox
          {...renderProps}
          {...props}
          checked={renderProps.value || false}
          inputRef={ref}
          onChange={e => renderProps.onChange(e.target.checked)}
        />
      )}
    />
  );
};
